
import {
    ALL_MAINTENANCE
   } from "../../constant/ActionType";
   
   export default function GetAllMaintenance(state = {
    allMaintenance: [],
   
   }, action) {
       switch (action.type) {
           case ALL_MAINTENANCE:
               return {
                   ...state,
                   allMaintenance: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }